import styled, { css } from 'styled-components';
import { Spacer } from '@lux/tokens';
import { screenBiggerThan, Screen } from '@client/styles/styled-components/breakpoints';

export const Container = styled.div`
    background-color: #f7f7f7;
    z-index: 1;
    position: relative;
    overflow: visible;
`;

export const GridWrapper = styled.div<{ isSimpleGrid?: boolean }>`
    width: 100%;
    display: grid;
    gap: ${Spacer.L};
    position: relative;

    ${({ isSimpleGrid = false }) =>
        isSimpleGrid &&
        css`
            grid-template-columns: repeat(2, 1fr);

            ${screenBiggerThan(Screen.smallTablet)} {
                grid-template-columns: repeat(3, 1fr);
            }

            ${screenBiggerThan(Screen.tablet)} {
                grid-template-columns: repeat(4, 1fr);
            }
        `}
`;
